import { useAppUser } from '@bechtel/client-common';
import { CommodityAssignee } from '@bechtel/types';

export function weldOwner(assignedCrewMembers?: CommodityAssignee[], crewMemberId?: string): boolean {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useAppUser();
  const idToCheck = crewMemberId || (user && user.id);
  if (assignedCrewMembers && assignedCrewMembers.length && idToCheck)
    return assignedCrewMembers.some((assignedCrewMember) => assignedCrewMember?.assignee?.id === idToCheck);
  return false;
}
